export const environment = {
  production: false,
  flettrackApi: 'https://staging.trackycontrol.com',
  trackycontrol: 'https://test.trackycontrol.com',
  //trackycontrol: 'http://localhost:8080',
  loginData: {
    username: 'cid-user',
    password: '6O8jWd9UA1]3Drp^.!Z.Z4',
    rememberMe: false
  }
};